// extracted by mini-css-extract-plugin
export var carrierIcon = "_wi-0";
export var carrierLogo = "_wi-1";
export var detailsSection = "_wi-2";